var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails01 = function SvgDetails01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "details-01_svg2__a",
    x1: 32.93,
    x2: 174.86,
    y1: 181.87,
    y2: 37.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#details-01_svg2__a",
    id: "details-01_svg2__b",
    x1: 14.66,
    x2: 156.59,
    y1: 163.95,
    y2: 19.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#details-01_svg2__a",
    id: "details-01_svg2__c",
    x1: 48.45,
    x2: 190.38,
    y1: 197.08,
    y2: 52.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#details-01_svg2__a",
    id: "details-01_svg2__d",
    x1: -4.38,
    x2: 137.55,
    y1: 145.28,
    y2: 0.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#details-01_svg2__a",
    id: "details-01_svg2__e",
    x1: 29.41,
    x2: 171.34,
    y1: 178.41,
    y2: 33.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#details-01_svg2__a",
    id: "details-01_svg2__f",
    x1: 33.71,
    x2: 175.64,
    y1: 182.62,
    y2: 37.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#details-01_svg2__a",
    id: "details-01_svg2__g",
    x1: 67.49,
    x2: 209.42,
    y1: 215.75,
    y2: 71
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.57 26.2h-18.09v-8.09c0-2.62-2.86-3.81-5.48-3.81h-14.05C117.62 4.78 109.29.02 99.76.02A21.68 21.68 0 0 0 78.57 14.3H64.76c-2.62 0-5.24 1.19-5.24 3.81v8.09H41.43c-10.72.11-19.49 8.57-20 19.28V181.9c0 10.48 9.52 18.09 20 18.09h117.13c10.48 0 20-7.62 20-18.09V45.49c-.5-10.71-9.28-19.17-20-19.28Zm-89.52-2.38h13.09a5.23 5.23 0 0 0 4.52-4.29A13.8 13.8 0 0 1 99.75 8.82c6.24.19 11.55 4.61 12.86 10.71a5.24 5.24 0 0 0 4.76 4.29h13.57v19.05h-61.9V23.82Zm89.52 166.66H41.43c-5.24 0-10.48-3.33-10.48-8.57V45.49c.49-5.45 5-9.66 10.48-9.76h18.09v12.14a4.993 4.993 0 0 0 5.24 4.52h70.23a5.24 5.24 0 0 0 5.48-4.52V35.73h18.09c5.47.1 9.99 4.31 10.48 9.76v136.42c0 5.24-5.24 8.57-10.48 8.57Z",
    style: {
      fill: "url(#details-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.67 106.44a4.77 4.77 0 0 0-6.67-.24l-15.24 14.52-6.43-6.67a4.77 4.77 0 0 0-6.67-.24 5.003 5.003 0 0 0 0 6.9l9.76 10c.84.95 2.07 1.47 3.33 1.43 1.26-.02 2.45-.53 3.33-1.43l18.57-17.62a4.52 4.52 0 0 0 .27-6.39c-.09-.1-.18-.19-.27-.28Z",
    style: {
      fill: "url(#details-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 116.67H95.24c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.76 4.76 4.76H150c2.63 0 4.76-2.13 4.76-4.76s-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#details-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.67 68.34A4.77 4.77 0 0 0 75 68.1L59.76 82.62l-6.43-6.67a4.77 4.77 0 0 0-6.67-.24 5.003 5.003 0 0 0 0 6.9l9.76 10c.84.95 2.07 1.47 3.33 1.43 1.26-.02 2.45-.53 3.33-1.43l18.57-17.62a4.52 4.52 0 0 0 .27-6.39c-.09-.1-.18-.19-.27-.28Z",
    style: {
      fill: "url(#details-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 78.58H95.24c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.76 4.76 4.76H150c2.63 0 4.76-2.13 4.76-4.76s-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#details-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.67 144.53a4.77 4.77 0 0 0-6.67-.24l-15.24 14.52-6.43-6.67a4.77 4.77 0 0 0-6.67-.24 5.003 5.003 0 0 0 0 6.9l9.76 10c.84.95 2.07 1.47 3.33 1.43 1.26-.02 2.45-.53 3.33-1.43l18.57-17.62a4.52 4.52 0 0 0 .27-6.39c-.09-.1-.18-.19-.27-.28Z",
    style: {
      fill: "url(#details-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 154.77H95.24c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.76 4.76 4.76H150c2.63 0 4.76-2.13 4.76-4.76s-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#details-01_svg2__g)"
    }
  }));
};
export default SvgDetails01;